import {
  Collapse,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Box,
} from "@mui/material";
import { Link } from "react-router-dom";
import GroupIcon from "@mui/icons-material/Group";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { grey } from "@mui/material/colors";

const EmployeeMenu = ({
  EmployeeCollapse,
  setEmployeeCollapse,
  open,
  employeeOptions,
  selectedMenu,
  handleMenuClick,
  isMobile,
  theme,
}) => {
  return (
    <>
      <ListItem
        disablePadding
        sx={{ display: "block", fontSize: "12px", marginTop: "2px" }}
      >
        <ListItemButton
          onClick={() => setEmployeeCollapse()}
          disableRipple
          selected={EmployeeCollapse}
          sx={{
            "&.Mui-selected:hover": {
              backgroundColor: "rgb(254 255 187 / 48%)",
            },
            ":hover": { backgroundColor: "rgb(254 255 187 / 48%)" },
            borderRadius: "8px",
            fontWeight: 600,
            minHeight: 44,
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: open ? "flex-start" : "center",
            gap: open ? 2 : 0,
            padding: open ? "8px 12px" : "8px",
            transition: "all 0.3s ease",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "24px",
              height: "24px",
            }}
          >
            <span
              style={{
                color: EmployeeCollapse
                  ? theme?.palette?.primary?.main
                  : theme.palette.mode === "dark"
                  ? theme.palette.text.primary
                  : theme.palette.text.secondary,
                transition: "color 0.3s ease",
              }}
            >
              <GroupIcon fontSize="small" />
            </span>
          </Box>
          {open && (
            <ListItemText
              primaryTypographyProps={{
                variant: "body2",
                fontWeight: EmployeeCollapse ? 600 : 550,
                fontSize: "0.8rem",
                color: EmployeeCollapse ? "primary" : grey[600],
              }}
              primary={"My Employee"}
              sx={{ margin: 0 }}
            />
          )}
          {open && (EmployeeCollapse ? <ExpandLess /> : <ExpandMore />)}
        </ListItemButton>
      </ListItem>
      <Collapse in={EmployeeCollapse} timeout="auto" unmountOnExit>
        <ListItem
          disablePadding
          sx={{ display: "block", fontSize: "12px", pl: 0, pt: 1, pb: 1 }}
        >
          <List sx={{ padding: "0px" }}>
            {employeeOptions.map((res, i) => {
              return (
                <Link
                  key={i}
                  to={res?.route}
                  style={{
                    color: theme.palette.mode === "dark" ? "white" : "black",
                  }}
                >
                  {res?.show && (
                    <ListItem
                      disablePadding
                      sx={{
                        display: "block",
                        fontSize: "12px",
                        marginLeft: `${isMobile ? "-4px" : ""}`,
                      }}
                      onClick={(e) => handleMenuClick(res?.label, res?.route)}
                    >
                      <ListItemButton
                        sx={{
                          "&.Mui-selected": {
                            backgroundColor:
                              theme?.palette?.primary?.main + "20",
                          },
                          borderRadius: "8px",
                          fontWeight: 600,
                          minHeight: 44,
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: open ? "flex-start" : "center",
                          gap: open ? 2 : 0,
                          padding: open ? "8px 12px" : "8px",
                          transition: "all 0.3s ease",
                        }}
                        selected={selectedMenu === res?.label}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "24px",
                            height: "24px",
                          }}
                        >
                          <span
                            style={{
                              color:
                                selectedMenu === res?.label
                                  ? theme?.palette?.primary?.main
                                  : theme.palette.mode === "dark"
                                  ? theme.palette.text.primary
                                  : theme.palette.text.secondary,
                              transition: "color 0.3s ease",
                            }}
                          >
                            {res?.icon}
                          </span>
                        </Box>
                        {open && (
                          <ListItemText
                            primaryTypographyProps={{
                              variant: "body2",
                              fontWeight:
                                selectedMenu === res?.label ? 600 : 550,
                              fontSize: "0.8rem",
                              color:
                                selectedMenu === res?.label
                                  ? "primary"
                                  : grey[600],
                            }}
                            primary={res?.label}
                            sx={{ margin: 0 }}
                          />
                        )}
                      </ListItemButton>
                    </ListItem>
                  )}
                </Link>
              );
            })}
          </List>
        </ListItem>
      </Collapse>
    </>
  );
};

export default EmployeeMenu;
